import CRUDActions from './CRUD';
import {VoDEvent} from '../api/stream/VoDEvent';
import {AwsVideo} from "../api/videoAws";
import {VideoModel} from "../api/video";

export class VoDActions extends CRUDActions {
  prefix = 'vod_event';

  get _model() {
    return VoDEvent;
  }

  /**
   *
   * @param {} model
   * @returns {function(*)}
   */
  publish(model: VoDEvent, data: any) {
    return async (dispatch) => {
      dispatch({
        type: this.saveItemAction,
        id: model.id
      });
      try {

        if (data.video instanceof VideoModel) {
          data.video = await AwsVideo.uploadVideo(data.video);
        }

        let updatedModel = await model.publish(data);

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model: updatedModel
        });

        return true;
      }
      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });
        return false;
      }
    }
  }
}

export const vodAction = new VoDActions();



// WEBPACK FOOTER //
// ./src/actions/vod.ts